import React from 'react';
import './BusinessDeatils.css';

export default function BusinessDeatils() {
  return (
   <>
    <section className="business-details">
      <div className="container">
        <h2>Our Business Credentials</h2>
        <p>
          We pride ourselves on being a transparent and reliable service provider. Here are our official business details for your reference.
        </p>
        <div className="details-grid">
          {/* <div className="detail-card">
            <i className="fas fa-receipt"></i>
            <h3>GST Number</h3>
            <p>21AAVCS6536M2ZO</p>
          </div> */}
          {/* <div className="detail-card">
            <i className="fas fa-id-card"></i>
            <h3>PAN Number</h3>
            <p>AAVCS6536M</p>
          </div> */}
          <div className="detail-card">
            <i className="fas fa-certificate"></i>
            <h3>ISO Certification</h3>
            <p>ISO 9001:2015</p>
          </div>
          <div className="detail-card">
            <i className="fas fa-building"></i>
            <h3>Registered Address</h3>
            <p>Plot No:9N16,4th Floor,<br/>Cowork venue,Arch Bishop's House, Satyanagar,Bhubaneswar,<br/>751007,Odisha,India</p>
          </div>
        </div>
      </div>
    </section>
   </>
  )
}
